import React from "react";

const ASP_Content_Linking = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Content Linking</h1>
      <p>This is the ASP Content Linking page content.</p>
    </div>
  );
};

export default ASP_Content_Linking;
